/**
 * @generated SignedSource<<af9cc78718da377a90aef1a9c09a82d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_user" | "PdpSharedDetailReference_user">;
  readonly " $fragmentType": "PdpRespDetails_user";
};
export type PdpRespDetails_user$key = {
  readonly " $data"?: PdpRespDetails_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetails_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDetails_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailFramingOptions_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "54048e6e50876137ff7e44a7f03cdf1a";

export default node;
